import { render, staticRenderFns } from "./GiftRemind.vue?vue&type=template&id=de23c078"
import script from "./GiftRemind.vue?vue&type=script&lang=js"
export * from "./GiftRemind.vue?vue&type=script&lang=js"
import style0 from "./GiftRemind.vue?vue&type=style&index=0&id=de23c078&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports